import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.prediction)?_c(VContainer,[_c('toolbar',{attrs:{"mode":"prediction","item":_vm.prediction}}),_c(VCard,{attrs:{"flat":""}},[_c('prediction',{attrs:{"applications":_vm.applications,"models":_vm.methods,"datasets":_vm.datasets,"prediction":_vm.prediction,"techniques":_vm.techniques},on:{"submitted":_vm.onSubmit}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }